import 'focus-visible';
import create from '@verndale/core';
import modules from './modules';
import AppBanner from './modules/appBanner';
import CookieBanner from './modules/cookieBanner/index';

let modulesCreated = false;

window.initCookieBanner = el => {
  window.cookieBanner = new CookieBanner(el);
};

document.addEventListener('DOMContentLoaded', () => {
  if (modulesCreated) return;
  modulesCreated = true;

  create(modules);

  new AppBanner({
    title: window.appBanner.title,
    description: window.appBanner.description,
    button: window.appBanner.button,
    score: {
      ios: window.appBanner.score.ios,
      android: window.appBanner.score.android
    },
    force: window.appBanner.force
  });
});
